import { styled } from '@mui/material/styles'
import TextField, { TextFieldProps } from '@mui/material/TextField'

type MyInputProps = TextFieldProps & {
  max?: number
  type?: string
  maxLength?: number
}

const StyledTextField = styled(TextField)({
  // Add your styles here
})

const SizeTextFieldInput = (props: MyInputProps) => {
  const { max, maxLength, ...rest } = props

  return (
    <StyledTextField
      {...rest}
      inputProps={{ max, maxLength }}
      style={{ fontSize: '14px' }}
      type={props.type ?? 'number'}
    />
  )
}

export default SizeTextFieldInput
